export default __webpack_public_path__ + "59240e7b0d1ce51d2bcda08e3bd7809c.svg";